import { FC } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'components/ui/tabs';
import { cn } from 'lib/utils';
import { PageCartoDataPanel } from './PageCartoDataPanel/PageCartoDataPanel';
import TextEditor from './PageCartoHyperTextPanel/TextEditor';
import { PageCartoIndicatorPanel } from './PageCartoIndicatorPanel/PageCartoIndicatorPanel';
import { PageCartoMapPanel } from './PageCartoMapPanel/PageCartoMapPanel';
import { PageCartoTags } from './PageCartoHyperTextPanel/PageCartoTags';
import { PageCartoLayerPanel } from './PageCartoLayerPanel/PageCartoLayerPanel';

export const PageCartoPanels: FC = () => {
  const tabs = [
    {
      id: 1,
      title: 'Hypertexte',
      content: <TextEditor />,
    },
    {
      id: 2,
      title: 'Couches',
      content: <PageCartoLayerPanel />,
    },
    {
      id: 3,
      title: 'Données',
      content: <PageCartoDataPanel />,
    },
    {
      id: 4,
      title: 'Indicateurs',
      content: <PageCartoIndicatorPanel />,
    },
    {
      id: 5,
      title: 'Carte',
      content: <PageCartoMapPanel />,
    },
    {
      id: 6,
      title: 'Tags',
      content: <PageCartoTags />,
    },
  ];
  const defaultTabId = tabs[0]?.id;

  return (
    <div
      className="h-full w-full flex flex-col box-border"
      data-testid="pagecarto-panels"
    >
      <div className="flex flex-col h-full">
        <Tabs
          {...(defaultTabId !== undefined
            ? { defaultValue: String(defaultTabId) }
            : {})}
          className="flex flex-col h-full"
        >
          <TabsList className="flex bg-blue-600 rounded-t-lg p-2 pb-0">
            {tabs.map((tab) => (
              <TabsTrigger
                key={tab.id}
                value={String(tab.id)}
                className={cn(
                  'rounded-t-lg p-2 text-sm font-medium leading-5 text-blue-100 hover:bg-white/10 hover:text-white',
                  'ring-blue ring-opacity-60 ring-offset-1 ring-offset-blue-400 focus:outline-none focus:ring-1',
                  'data-[state=active]:bg-white data-[state=active]:text-blue-700 data-[state=active]:shadow'
                )}
              >
                {tab.title}
              </TabsTrigger>
            ))}
          </TabsList>
          {tabs.map((tab) => (
            <TabsContent
              key={tab.id}
              value={String(tab.id)}
              className="box-border px-2 rounded-b-lg border border-blue-700 overflow-y-auto h-full"
            >
              <div className="m-2 h-full">{tab.content}</div>
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </div>
  );
};
